<template>
  <div class="box">
    <div class="header">
      <i
        v-if="!iscollapse"
        @click="changMenu"
        class="iconfont icon-shousuo"
        title="点击收缩"
      ></i>
      <i
        v-else
        @click="changMenu"
        class="iconfont icon-zhankai1"
        title="点击展开"
      ></i>
      <i
        class="outicon iconfont icon-tuichu"
        title="点击退出"
        @click="logout"
      ></i>
      <font class="txt">欢迎您！{{ username }}，您上次登录时间 {{ time }}</font>
    </div>
    <!--内容-->
    <div class="content"><router-view></router-view></div>
  </div>
</template>

<script>
export default {
  props: ["iscollapse"],
  data() {
    return {
      username: localStorage.getItem("username"),
      time: localStorage.getItem("time"),
    };
  },
  methods: {
    changMenu() {
      //传值给父级
      this.$emit("changCollapse");
    },
    logout() {
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 验证通过之后的操作
          //window.sessionStorage.clear();
          localStorage.removeItem("_admintoken_");
          this.$router.push("/");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>

.box {
  .header {
    height: 50px;
    line-height: 50px;
    // background: #054476 !important;
    color: #000000;
    font-size: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .iconfont {
      font-size: 22px;
      padding-left: 5px;
    }
    i {
      cursor: pointer;
    }
    .txt {
      font-size: 12px;
      float: right;
      padding-right: 10px;
    }
    .outicon {
      float: right;
      padding-right: 20px;
    }
  }
  .content {
    padding: 20px;
    background-color: #f6f7f9;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/manage_views/content.vue